import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { updateShowChangeEmailModal, updateShowChangeEmailSuccessModal } from '../../../../actions/modal';
import { changeUserEmail, updateUserProfileWithNewEmail } from '../../../../actions/user';

import Info from '../../info';

const commonClass = 'ui labeled icon button color-white left-text max-width';

const RightPanelChangeEmail = ({ dispatch, formik, currentEmail }) => {
  return (
    <div className="right-panel">
      <Container fluid as={Media} at="mobile">
        <p className="mrtxs">{APP.LANGUAGE.ChangeEmail.MobileInfo}</p>
      </Container>
      <div className="ui actions mrbl max-width mrtxs">
        <button
          disabled={formik.values.newEmail === '' ? true : !formik.isValid}
          type="button"
          data-group="changePasswordForm"
          className={`${commonClass} color-button color-button-hover`}
          onClick={() => {
            changeUserEmail(
              {
                currentEmail: currentEmail,
                newEmail: formik.values.newEmail.trim(),
                password: formik.values.newPassword.trim(),
              },
              () => {
                dispatch(updateUserProfileWithNewEmail(formik.values.newEmail));
                dispatch(updateShowChangeEmailSuccessModal(true));
              },
              (err) => {
                var error =
                  APP.LANGUAGE.ServerErrors[err] ||
                  APP.LANGUAGE.Errors[err] ||
                  APP.LANGUAGE.ServerErrors.GeneralApiError;
                if (error.toLowerCase().indexOf('password') > -1) {
                  formik.setFieldValue('newPassword', '');
                } else if (error.toLowerCase().indexOf('email') > -1) {
                  formik.setFieldError('newEmail', APP.LANGUAGE.ChangeEmail.NewEmailError.V3);
                }
              }
            );
          }}
        >
          <i className="checkmark icon" />
          {APP.LANGUAGE.ChangeEmail.Ok}
        </button>
        <button
          type="button"
          className={`${commonClass} color-bad-things color-bad-things-hover mrtm`}
          onClick={() => {
            dispatch(updateShowChangeEmailModal(false));
          }}
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.ChangeEmail.Cancel}
        </button>
      </div>
      <Info paragraphs={[APP.LANGUAGE.ChangeEmail.Info]} />
    </div>
  );
};

RightPanelChangeEmail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  formik: PropTypes.object.isRequired,
};

export default RightPanelChangeEmail;
